import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

export const TOKEN_KEY = "axiora_token";

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => {
    // Detecta datos servidos desde caché (puente en reposo momentáneo) para el aviso global.
    try {
      const url = res.config?.url || "";
      const isGet = (res.config?.method || "get").toLowerCase() === "get";
      if (isGet && url.includes("/comando/") && res.data && typeof res.data === "object") {
        if (res.data._stale) {
          window.dispatchEvent(new CustomEvent("axiora-bridge-stale", { detail: { at: res.data._actualizado_at } }));
        } else if (!res.data.puente_pendiente) {
          window.dispatchEvent(new Event("axiora-bridge-fresh"));
        }
      }
    } catch (e) { /* noop */ }
    return res;
  },
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem(TOKEN_KEY);
      window.dispatchEvent(new Event("axiora-unauth"));
    }
    return Promise.reject(error);
  }
);

export default api;
